const defaultState = {}

const interactiveelements = (state = defaultState, action) => {
  switch (action.type) {
    case 'INTERACTIVE_ELEMENTS_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default interactiveelements



// WEBPACK FOOTER //
// ./src/reducers/interactiveelements.js